/* eslint-disable react-hooks/exhaustive-deps */
import React, {  useEffect, useState } from "react";
import { AiFillFlag, AiOutlineCloseCircle } from "react-icons/ai";
import { FaUserGroup } from "react-icons/fa6";
import { IoCall, IoRestaurant } from "react-icons/io5";
import { MdEmail, MdOutlineWatchLater } from "react-icons/md";
import ReactQuill from "react-quill";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { saveActivity } from "../../Redux/CommonSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiData } from "../../Redux/organizationSlice";
import moment from "moment";
import { getAllPerson } from "../../Redux/PersonSlice";
import { getAllDeals } from "../../Redux/DealSlice";
import ReactSelect from "../Common/ReactSelect";
import { MettingTypes, Phase } from "../Common/Common";
import { getLeadmaster } from "../../Redux/LeadsSlice";
import { getProject } from "../../Redux/ProjectSlice";

export default function AddActivity({
  togglemodel,
  setloadFrist,
  editActivityData,
  TemplateID, MovePhase, AddTemplates, ProjectId, PhaseName
}) {
  const dispatch = useDispatch();
  const organizationstore = useSelector((state) => state.root.organization);
  const Peoplestore = useSelector((state) => state.root.Person);
  const Dealstore = useSelector((state) => state.root.Deal);
  const Leadstore = useSelector((state) => state.root.leads);
  const Projectstore = useSelector((state) => state.root.Project);


  const [labelActivityPlaceholder, setLabelActivityPlaceholder] = useState("Call");
  const [activityName, setActivityName] = useState("");
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [startTime, setStartTime] = useState(moment().format("HH:mm"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [endTime, setEndTime] = useState(moment().format("HH:mm"));
  const [guestvalus, setGuestvalus] = useState("");
  const [selectedMeeting, setSelectedMeeting] = useState("Zoom Meeting");
  const [location, setLocation] = useState("");
  const [notes, setNotes] = useState("");
  const [description, setDescription] = useState("");
  const [availableType, setAvailableType] = useState("Free");
  const [Priority, setPriority] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("");
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [markAsDone, setmarkAsDone] = useState(false);
  const [Error, setError] = useState('');
  const [CalendarEvents, setCalendarEvents] = useState([]);
  const [Day, setDay] = useState('');
  const [selectedPhase, setselectedPhase] = useState({ value: 0, label: `${PhaseName ? PhaseName : 'Phase unassigned'}`, });

  useEffect(() => {
    dispatch(fetchApiData({}));
    dispatch(getAllPerson({}));
    dispatch(getAllDeals({}));
    dispatch(getLeadmaster({ search: '', limit: 0, pageNumber: 0, objSearch: {} }))
    dispatch(getProject({}))
  }, [dispatch]);

  useEffect(() => {
    const startDateTime = new Date(`${startDate}T${startTime}`).toISOString();
    const endDateTime = new Date(`${endDate}T${endTime}`).toISOString();
    setCalendarEvents({
      title: labelActivityPlaceholder,
      start: startDateTime,
      end: endDateTime,
    },)
  }, [startDate, endDate, startTime, endTime, labelActivityPlaceholder]);

  useEffect(() => {

    if (editActivityData) {
      // toast.loading("Fetching...")
      setActivityName(editActivityData?.activityName ? editActivityData?.activityName : activityName);
      setGuestvalus(editActivityData?.guests ? editActivityData?.guests : guestvalus);
      setLabelActivityPlaceholder(editActivityData?.activityType ? editActivityData?.activityType : labelActivityPlaceholder);

      if (editActivityData && editActivityData?.meetingType) { setSelectedMeeting({ label: editActivityData?.meetingType, value: editActivityData?.meetingType, }); }
      setLocation(editActivityData?.locations ? editActivityData?.locations : location);
      setNotes(editActivityData?.notes ? editActivityData?.notes : notes);
      setmarkAsDone(editActivityData?.markAsDone ? editActivityData?.markAsDone : markAsDone)
      setDescription(editActivityData?.description ? editActivityData?.description : description);
      setAvailableType(editActivityData?.availableType ? editActivityData?.availableType : availableType);
      setPriority(editActivityData?.priority ? editActivityData?.priority : Priority);
      setDay(editActivityData?.day ? editActivityData?.day : Day)
      if (editActivityData?.phase) { setselectedPhase({ label: editActivityData?.phase, value: editActivityData?.phase }); }

      if (editActivityData?.organizationID) { setSelectedOrganization({ label: editActivityData?.organizationName, value: editActivityData?.organizationID, }); }
      if (editActivityData?.peopleID) { setSelectedPerson({ label: editActivityData?.peopleName, value: editActivityData?.peopleID, }); }
      if (editActivityData?.dealID) { setSelectedDeal({ label: editActivityData?.dealName, value: editActivityData?.dealID, }); }
      if (editActivityData?.leadID) { setSelectedLead({ label: editActivityData?.leadName, value: editActivityData?.leadID, }); }
      if (editActivityData?.projectID) { setSelectedProject({ label: editActivityData?.projectName, value: editActivityData?.projectID, }); }
    }
  }, [editActivityData]);

  useEffect(() => {
    if (editActivityData?.endDate) { setEndDate(moment(editActivityData?.endDate).format("YYYY-MM-DD")); }
    if (editActivityData?.startDate) { setStartDate(editActivityData?.startDate ? moment(editActivityData?.startDate).format("YYYY-MM-DD") : startDate) }
    setEndTime(editActivityData?.endTime ? editActivityData?.endTime : endTime);
    setStartTime(editActivityData?.startTime ? editActivityData?.startTime : startTime);
  }, [editActivityData?.endDate, editActivityData?.startDate, editActivityData?.endTime,]);

  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    setStartDate(newStartDate);
    const MatchDates = newStartDate === endDate
    setEndDate(MatchDates ? endDate : newStartDate > endDate ? newStartDate : endDate)
  };

  const handleStartTimeChange = (e) => {
    const newStartTime = e.target.value;
    setStartTime(newStartTime);
    const MatchDates = newStartTime === endTime
    setEndTime(MatchDates ? endTime : newStartTime > endTime ? newStartTime : endTime)
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setEndDate(newEndDate);
  };

  const handleEndTimeChange = (e) => {
    const newEndTime = e.target.value;
    setEndTime(newEndTime);
    setStartTime(newEndTime < startTime ? newEndTime : startTime)
  };

  const handleIconClick = (placeholder) => { setLabelActivityPlaceholder(placeholder); };
  const handleContentGuestChange = (newContent) => { setNotes(newContent); };
  const handleOrgChange = (option) => { setSelectedOrganization(option); };
  const handlePersonChange = (option) => { setSelectedPerson(option); };
  const handleDealChange = (option) => { setSelectedDeal(option); };


  const handleSaveActivity = async (e) => {
    e.preventDefault()
    if (!activityName) {
      setError('Activity Name is Required');
      return;
    }

    const payload = {
      activityID: editActivityData?.activityID ? editActivityData?.activityID : 0,
      activityName: activityName,
      activityType: labelActivityPlaceholder,
      startTime: startTime,
      startDate: startDate,
      endDate: endDate,
      endTime: endTime,
      guests: guestvalus,
      locations: location,
      meetingType: selectedMeeting.label,
      description: description,
      availableType: availableType,
      notes: notes,
      userID: 0,
      dealID: selectedDeal?.value,
      peopleID: selectedPerson?.value,
      organizationID: selectedOrganization?.value,
      markAsDone: markAsDone,
      identityID: selectedOrganization?.value,
      identityName: "Activity",
      day: Day,
      phase: TemplateID ? selectedPhase?.label : "",
      type: TemplateID ? "ProjectTemplate" : "Activity",
      leadID: selectedLead?.value,
      projectID: selectedProject?.value,
      priority: Priority
    };

    const res = await dispatch(saveActivity(payload))
    const taskData = res?.payload?.data
    if (TemplateID && !editActivityData?.phaseId) {
      AddTemplates(taskData)
    } else if (editActivityData?.phaseId) {
      MovePhase(taskData)
    }

    if (res?.payload?.status === true) {
      setloadFrist(true);
      togglemodel();
      setError('')
      setCalendarEvents([])
    }
  };

  const modalTitle = `${editActivityData?.activityID ? "Edit " : ""}Schedule an activity`;
  const inputClass = "w-full min-h-[38px] rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 shadow-none outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100";
  const labelClass = "mb-1.5 block text-xs font-bold text-slate-600";
  const fieldClass = "min-w-0";
  const errorClass = "mt-1 text-xs font-bold text-red-600";
  const sectionClass = "min-w-0 rounded-lg border border-slate-200 bg-white shadow-sm";
  const sectionHeaderClass = "flex items-center gap-2 border-b border-slate-100 px-3.5 py-3";
  const sectionContentClass = "flex flex-col gap-3.5 p-3.5";
  const sectionDotClass = "h-2 w-2 rounded-full bg-indigo-600 shadow-[0_0_0_4px_#eef2ff]";
  const sectionDotBlueClass = "h-2 w-2 rounded-full bg-blue-600 shadow-[0_0_0_4px_#eff6ff]";
  const activityTypeButtonClass = (type) => (
    `inline-flex min-h-[34px] min-w-[46px] items-center justify-center border-r border-slate-200 bg-white text-slate-600 transition last:border-r-0 hover:bg-indigo-50 hover:text-indigo-600 ${labelActivityPlaceholder === type ? "bg-indigo-50 text-indigo-600" : ""}`
  );

  return (
    <div
      id="default-modal"
      tabIndex="-1"
      aria-hidden="true"
      className="fixed inset-0 z-[9999] flex min-h-screen w-full items-center justify-center bg-slate-900/60 p-6 backdrop-blur-[2px]"
    >
      <div className="max-h-[calc(100vh-48px)] w-full max-w-[1088px]">
        <div className="overflow-hidden rounded-[10px] border border-slate-200 bg-white shadow-[0_24px_70px_rgba(15,23,42,0.22)]">
          <div className="flex items-center justify-between gap-4 border-b border-slate-200 bg-white px-5 py-4">
            <h3 className="m-0 text-lg font-bold leading-tight text-slate-900">{modalTitle}</h3>
            <AiOutlineCloseCircle
              className="shrink-0 cursor-pointer text-[28px] text-slate-500 transition hover:scale-[1.03] hover:text-indigo-600"
              onClick={() => togglemodel()}
            />
          </div>
          <form >
            <div className="bg-slate-50 px-5 py-4">
              <div className="vertical-scroll-inner grid max-h-[min(62vh,560px)] grid-cols-[minmax(0,1fr)_minmax(360px,0.95fr)] gap-4 overflow-y-auto pr-1.5 max-[900px]:grid-cols-1">
                <div className={sectionClass}>
                  <div className={sectionHeaderClass}>
                    <span className={sectionDotClass} />
                    <h4 className="m-0 text-[13px] font-bold leading-tight text-slate-800">Activity details</h4>
                  </div>
                  <div className={sectionContentClass}>
                    <div className={fieldClass}>
                      <div className="rounded-lg border border-slate-200 bg-white p-3">
                        <input
                          type="text"
                          name="activityName"
                          placeholder={labelActivityPlaceholder}
                          className={`${inputClass} font-semibold capitalize`}
                          defaultValue={editActivityData?.activityName}
                          onChange={(e) => setActivityName(e.target.value)}
                        />
                        {activityName && activityName.length > 0 ? "" : Error && (
                          <div className={errorClass}>{Error}</div>
                        )}
                        <div
                          className="mt-2.5 inline-flex overflow-hidden rounded-lg border border-slate-200"
                          role="group"
                        >
                          <button
                            type="button"
                            className={activityTypeButtonClass("Call")}
                            onClick={() => handleIconClick("Call")}
                          >
                            <IoCall />
                          </button>
                          <button
                            type="button"
                            className={activityTypeButtonClass("Meeting")}
                            onClick={() => handleIconClick("Meeting")}
                          >
                            <FaUserGroup />
                          </button>
                          <button
                            type="button"
                            className={activityTypeButtonClass("Task")}
                            onClick={() => handleIconClick("Task")}
                          >
                            <MdOutlineWatchLater />
                          </button>
                          <button
                            type="button"
                            className={activityTypeButtonClass("Deadline")}
                            onClick={() => handleIconClick("Deadline")}
                          >
                            <AiFillFlag />
                          </button>
                          <button
                            type="button"
                            className={activityTypeButtonClass("Email")}
                            onClick={() => handleIconClick("Email")}
                          >
                            <MdEmail />
                          </button>
                          <button
                            type="button"
                            className={activityTypeButtonClass("Lunch")}
                            onClick={() => handleIconClick("Lunch")}
                          >
                            <IoRestaurant />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className={fieldClass}>
                      {
                        TemplateID ? (
                          <div className="grid grid-cols-[120px_minmax(0,1fr)] items-center gap-2.5 max-[900px]:grid-cols-1">
                            <input
                              type="number"
                              min="0"
                              className={inputClass}
                              value={Day}
                              onChange={(e) => {
                                let inputValue = e.target.value.replace(/\D/g, '');
                                if (inputValue.length > 4) {
                                  inputValue = inputValue.slice(0, 4);
                                }
                                setDay(inputValue);
                              }}
                            />
                            <span className="text-[13px] font-semibold text-slate-600">days from <strong className="text-slate-900">project start date</strong></span>
                          </div>
                        ) :
                          <div className="flex flex-col gap-2.5">
                            <div className="grid grid-cols-[minmax(0,1fr)_minmax(130px,0.75fr)] gap-2.5 max-[900px]:grid-cols-1">
                              <input
                                datepicker
                                name="start_date"
                                type="date"
                                className={inputClass}
                                placeholder="Select date"
                                onChange={handleStartDateChange}
                                value={startDate}
                              />
                              <input
                                type="time"
                                name="start_time"
                                value={startTime}
                                className={inputClass}
                                onChange={handleStartTimeChange}
                              />
                            </div>
                            <div className="grid grid-cols-[minmax(0,1fr)_minmax(130px,0.75fr)] gap-2.5 max-[900px]:grid-cols-1">
                              <input

                                name="end_date"
                                min={startDate}
                                onChange={handleEndDateChange}
                                value={endDate}
                                type="date"
                                className={inputClass}
                                placeholder="Select date"
                              />
                              <input
                                type="time"
                                name="end_time"
                                required
                                min={startTime || '00:00'}
                                value={endTime}
                                className={inputClass}
                                onChange={handleEndTimeChange}
                              />
                            </div>
                          </div>
                      }
                    </div>

                    {TemplateID ? (
                      <div className={fieldClass}>
                        <label className={labelClass}>Phase</label>
                        <ReactSelect
                          selectedValue={selectedPhase}
                          options={
                            Phase &&
                              Phase?.length > 0
                              ? Phase.map((item) => ({
                                value: item?.id ?? "",
                                label: item?.name,
                              }))
                              : [{ value: "", label: "Not Found" }]
                          }
                          handleSelectChange={(option) => setselectedPhase(option)}
                        />
                      </div>
                    )
                      : (
                        <>
                          <div className={fieldClass}>
                            <label
                              htmlFor="Guests"
                              className={labelClass}
                            >
                              Guests
                            </label>
                            <input
                              type="text"
                              id="Guests"
                              name="guests"
                              className={`${inputClass} capitalize`}
                              defaultValue={editActivityData?.guests}
                              onChange={(e) => setGuestvalus(e.target.value)}
                            />
                          </div>
                          <div className="grid grid-cols-2 gap-3 max-[900px]:grid-cols-1">
                            <div className={fieldClass}>
                              <label
                                htmlFor="Guests"
                                className={labelClass}
                              >
                                Location
                              </label>
                              <input
                                type="text"
                                name="location"
                                placeholder="Location"
                                className={inputClass}
                                defaultValue={editActivityData?.locations}
                                onChange={(e) => setLocation(e.target.value)}
                              />
                            </div>
                            <div className={fieldClass}>
                              <label htmlFor="Priority" className={labelClass}>Priority</label>
                              <select
                                value={Priority}
                                onChange={(e) => setPriority(e.target.value)}
                                className={inputClass}
                              >
                                <option className="hidden" >Priority</option>
                                <option className="m-5 text-base" value="None">None</option>
                                <option className="m-5 text-base" value="HIGH">HIGH</option>
                                <option className="m-5 text-base" value="MEDIUM">MEDIUM</option>
                                <option className="m-5 text-base" value="LOW">LOW</option>
                              </select>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-3 max-[900px]:grid-cols-1">
                              <div className={fieldClass}>
                                <label
                                  htmlFor="Guests"
                                  className={labelClass}
                                >
                                  Install video call integration
                                </label>
                                <ReactSelect
                                  selectedValue={selectedMeeting}
                                  options={
                                    MettingTypes && MettingTypes?.length > 0
                                      ? MettingTypes.map((item) => ({
                                        value: item?.value ?? "",
                                        label: item?.label,
                                      }))
                                      : [{ value: "", label: "Not Found" }]
                                  }
                                  handleSelectChange={(option) =>
                                    setSelectedMeeting(option)
                                  }
                                />
                              </div>
                              <div className={fieldClass}>
                                <label className={labelClass}>Availability</label>
                                <select
                                  value={availableType}
                                  onChange={(e) => setAvailableType(e.target.value)}
                                  className={inputClass}
                                >
                                  <option value="Free">Free</option>
                                  <option value="Busy">Busy</option>
                                </select>
                              </div>
                          </div>
                        </>
                      )
                    }
                    <div className={fieldClass}>
                      <label
                        htmlFor="Guests"
                        className={labelClass}
                      >
                        Description
                      </label>
                      <textarea
                        type="textarea"
                        name="location"
                        placeholder="Description"
                        className={`${inputClass} min-h-24 resize-y`}
                        defaultValue={editActivityData?.description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                    <div className={fieldClass}>
                      <div className="overflow-hidden rounded-lg border border-slate-300 [&_.ql-container]:min-h-28 [&_.ql-container]:border-0 [&_.ql-container]:text-sm [&_.ql-container.ql-snow]:border-0 [&_.ql-toolbar.ql-snow]:border-0 [&_.ql-toolbar.ql-snow]:border-b [&_.ql-toolbar.ql-snow]:border-slate-200">
                        <ReactQuill
                          theme="snow"
                          value={notes ? notes : editActivityData?.notes}
                          onChange={handleContentGuestChange}
                        />
                      </div>
                      <small className="mt-1.5 block text-xs text-slate-500">
                        Notes are visible within crm, but not to event guests
                      </small>
                    </div>

                    <div className={fieldClass}>
                      <label
                        className={labelClass}
                      >
                        Lead
                      </label>
                      <ReactSelect
                        selectedValue={selectedLead}
                        options={
                          Leadstore && Leadstore?.leadsData?.length > 0
                            ? Leadstore.leadsData.map((item) => ({
                              value: item?.leadID,
                              label: item?.title,
                            }))
                            : [{ value: "", label: "Not Found" }]
                        }
                        handleSelectChange={(option) => { setSelectedLead(option) }}
                      />
                    </div>
                    <div className={fieldClass}>
                      <label
                        className={labelClass}
                      >
                        Project
                      </label>
                      <ReactSelect
                        selectedValue={selectedProject}
                        options={
                          Projectstore && Projectstore?.getProject?.length > 0
                            ? Projectstore.getProject.map((item) => ({
                              value: item?.projectID,
                              label: item?.title,
                            }))
                            : [{ value: "", label: "Not Found" }]
                        }
                        handleSelectChange={(option) => { setSelectedProject(option) }}
                      />
                    </div>
                    <div className={fieldClass}>
                      <label
                        className={labelClass}
                      >
                        Deal
                      </label>
                      <ReactSelect
                        selectedValue={selectedDeal}
                        options={
                          Dealstore && Dealstore?.getDeals?.length > 0
                            ? Dealstore.getDeals.map((item) => ({
                              value: item?.dealID,
                              label: item?.title,
                            }))
                            : [{ value: "", label: "Not Found" }]
                        }
                        handleSelectChange={handleDealChange}
                      />
                    </div>
                    <div className={fieldClass}>
                      <label
                        className={labelClass}
                      >
                        Contact Person
                      </label>
                      <ReactSelect
                        selectedValue={selectedPerson}
                        options={
                          Peoplestore && Peoplestore?.getAllPerson?.length > 0
                            ? Peoplestore.getAllPerson.map((item) => ({
                              value: item?.personMasterID ?? "",
                              label: item?.name,
                            }))
                            : [{ value: "", label: "Not Found" }]
                        }
                        handleSelectChange={handlePersonChange}
                      />
                    </div>
                    <div className={fieldClass}>
                      <label
                        className={labelClass}
                      >
                        Organization
                      </label>
                      <ReactSelect
                        selectedValue={selectedOrganization}
                        options={
                          organizationstore &&
                            organizationstore?.organizationData?.data?.length > 0
                            ? organizationstore?.organizationData?.data.map(
                              (item) => ({
                                value: item?.organizationID ?? "",
                                label: item?.organizationName,
                              })
                            )
                            : [{ value: "", label: "Not Found" }]
                        }
                        handleSelectChange={handleOrgChange}
                      />
                    </div>
                  </div>
                </div>
                {
                  !TemplateID && (
                    <div className={sectionClass}>
                      <div className={sectionHeaderClass}>
                        <span className={sectionDotBlueClass} />
                        <h4 className="m-0 text-[13px] font-bold leading-tight text-slate-800">Calendar preview</h4>
                      </div>
                      <div className={sectionContentClass}>
                        <div className="h-full overflow-auto rounded-lg border border-slate-200 bg-white p-3 max-[640px]:h-[420px] [&_.fc_.fc-button]:rounded-md [&_.fc_.fc-button]:border-indigo-200 [&_.fc_.fc-button]:bg-indigo-50 [&_.fc_.fc-button]:text-indigo-600 [&_.fc_.fc-button]:shadow-none [&_.fc_.fc-button:focus]:border-indigo-600 [&_.fc_.fc-button:focus]:bg-indigo-600 [&_.fc_.fc-button:focus]:text-white [&_.fc_.fc-button:focus]:shadow-none [&_.fc_.fc-button:hover]:border-indigo-600 [&_.fc_.fc-button:hover]:bg-indigo-600 [&_.fc_.fc-button:hover]:text-white [&_.fc_.fc-toolbar-title]:text-sm [&_.fc_.fc-toolbar-title]:font-bold [&_.fc_.fc-toolbar-title]:uppercase [&_.fc_.fc-toolbar-title]:text-slate-700 [&_.fc_.fc-toolbar]:mb-3.5 [&_.fc_.fc-toolbar]:gap-2 [&_.fc]:text-[13px]">
                          <FullCalendar
                            eventColor="blue"
                            selectMirror
                            weekends
                            headerToolbar={{
                              left: 'prev,next',
                              center: 'title',
                              right: 'timeGridDay',
                            }}
                            nowIndicator={true}
                            plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
                            initialView="timeGridDay"
                            slotLabelFormat={{
                              hour: 'numeric',
                              minute: '2-digit',
                              omitZeroMinute: false,
                              hour12: true,
                            }}
                            // eventContent={renderEventContent}
                            // titleFormat={{
                            //   year: 'numeric',
                            //   month: 'long',
                            //   day: 'numeric',
                            //   weekday: 'long'
                            // }}
                            events={[CalendarEvents]}
                          />
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
            <div className="flex items-center justify-between gap-2.5 border-t border-slate-200 bg-white px-5 py-3">
              <button
                type="button"
                className="inline-flex min-h-9 items-center justify-center rounded-lg border border-slate-200 bg-white px-4 py-2 text-[13px] font-bold text-slate-600 transition hover:border-red-200 hover:bg-red-50 hover:text-red-600"
                onClick={() => togglemodel()}
              >
                Close
              </button>

              <div className="flex items-center gap-3 max-[640px]:flex-wrap max-[640px]:justify-end">
                  <input
                    type="checkbox"
                    id="markAsDone"
                    className="h-4 w-4 accent-indigo-600"
                    checked={markAsDone}
                    onChange={(e) => {
                      setmarkAsDone(e.target.checked);
                    }}
                  />
                  <label htmlFor='markAsDone' className="whitespace-nowrap text-[13px] font-semibold text-slate-700">
                    Mark as done
                  </label>
                <button
                  type="button"
                  className="inline-flex min-h-9 items-center justify-center rounded-lg border border-indigo-600 bg-indigo-600 px-4 py-2 text-[13px] font-bold text-white transition hover:border-indigo-700 hover:bg-indigo-700"
                  onClick={(e) => handleSaveActivity(e)}
                >
                  {editActivityData?.activityID ? "Update" : "Save"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
